/**
 * The External Library's sources (Huanrui, 2026-10-14): Amazon and Google
 * Images behind one search, chosen from a menu in front of the search box --
 * on the website and in the Miro panel. (Unsplash was a third until
 * 2026-10-27, and taken out: Huanrui.)
 */
export type ExternalSource = 'amazon' | 'google'

export const EXTERNAL_SOURCES: { value: ExternalSource; label: string }[] = [
  { value: 'amazon', label: 'Amazon' },
  { value: 'google', label: 'Google' },
]

/** A source still offered; a choice kept from before (Unsplash) is not, and falls back. */
export const isExternalSource = (value: unknown): value is ExternalSource => value === 'amazon' || value === 'google'
